'use strict';
angular
    .module('dnapp')
    .factory('DNDepartments.NewsListService', ['$resource', function ($resource) {
        return $resource('/umbraco/frontend/NewsApi/:action', {}, {
            getNews: { method: "GET", params: { action: "GetNews" } }
        });
    }]);